import { render, staticRenderFns } from "./exchangeGoodDetail.vue?vue&type=template&id=4e4f7718&scoped=true"
import script from "./exchangeGoodDetail.vue?vue&type=script&lang=js"
export * from "./exchangeGoodDetail.vue?vue&type=script&lang=js"
import style0 from "./exchangeGoodDetail.vue?vue&type=style&index=0&id=4e4f7718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f7718",
  null
  
)

export default component.exports